import angular from 'angular';
import uiRouter from 'angular-ui-router';
import reportImages from './reportImages.component';

let reportImagesModule = angular.module('reportImages', [
    uiRouter
])

.component('reportImages', reportImages)

    .name;

export default reportImagesModule;



// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.js